import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

interface Props {
  isPrivateEvent?: boolean;
  isMultipleEventDirectories?: boolean;
}

export const useStyles = makeStyles<Theme, Props>((theme) => ({
  inputAdornment: ({ isPrivateEvent, isMultipleEventDirectories }) => ({
    display: "flex",
    width: isPrivateEvent && isMultipleEventDirectories ? "110px" : "70px",
  }),
  toolTip: {
    textAlign: "left",
    background: theme.palette.white,
    boxShadow: `4px 4px 4px 4px ${theme.palette.boxShadow.default}`,
    color: theme.palette.events.textPrimary,
    fontSize: "14px",
    lineHeight: "21px",
  },
  toolTipArrow: {
    color: theme.palette.white,
    background: "transparent",
  },
  lockIcon: ({ isPrivateEvent, isMultipleEventDirectories }) => ({
    padding: isPrivateEvent && isMultipleEventDirectories ? "0 5px" : 0,
    "& path": {
      fill: theme.palette.events.blueSecondary,
    },
  }),
  linkIcon: {
    "& path": {
      fill: theme.palette.events.blueSecondary,
    },
  },
  inputContainer: {
    paddingRight: "4px",
  },
}));
